import type { RoutePathOptionType } from './type';

export const httpStatusCodes = {
  UNAUTHORIZED: 401,
  BAD_REQUEST: 400,
  SERVER_FAILED: 500,
};

export const routePathOptions: RoutePathOptionType[] = [
  {
    path: '/dashboard',
    label: 'Dashboard',
  },
  {
    path: '/orders',
    label: 'Orders',
    formType: {
      create: 'Add Order Details',
      edit: 'Edit Order Details',
      'order-summary': 'Order Summary',
    },
    showBackIcon: true,
    previousUrl: '/select-outfit',
  },
  {
    path: '/select-customer',
    label: 'Select or add customer',
    showBackIcon: true,
    previousUrl: '/dashboard',
  },
  {
    path: '/select-outfit',
    label: 'Select Outfits',
    showBackIcon: true,
    previousUrl: '/select-customer',
  },
  {
    path: '/orders-list',
    label: 'Orders',
  },
  {
    path: '/customers',
    label: 'Customers',
  },
];

export const moneyFormatSigns = {
  rupee: '\u20B9',
};

export const GA_ID = 'G-67MM2LW547';

export const botId = 'clw8ffx8u01aouu0wonlp70b1';
export const routesToAllowedForAIBot = ['dashboard'];

export const constantFileNameBasedOnPathName: Record<string, string> = {
  dashboard: 'dashboard',
  customers: 'customers',
  'orders-list': 'orders',
  'select-customer': 'customers',
  'select-outfit': 'orders',
  orders: 'orders',
  login: 'login',
  onboarding: 'profile',
};

export const languageList = [
  {
    label: 'English',
    value: 'en',
  },
  {
    label: 'Hindi',
    value: 'hi',
  },
  {
    label: 'Punjabi',
    value: 'pa',
  },
  {
    label: 'Gujarati',
    value: 'gu',
  },
  {
    label: 'Marathi',
    value: 'mr',
  },
  {
    label: 'Telugu',
    value: 'te',
  },
  {
    label: 'Bengali',
    value: 'bn',
  },
  {
    label: 'Kannada',
    value: 'kn',
  },
  {
    label: 'Malyalam',
    value: 'ml',
  },
  {
    label: 'Odia',
    value: 'or',
  },
  {
    label: 'Assamese',
    value: 'as',
  },
  {
    label: 'tamil',
    value: 'ta',
  },
  {
    label: 'Urdu',
    value: 'ur',
  },
];
